import { client } from "api";
import { Company } from "models/Company";

export type ApproveCompanyRequest = {
  companyId: string;
};

export type ApproveCompanyResponse = Company;

export const approveCompany = ({ companyId }: ApproveCompanyRequest) =>
  client.post<ApproveCompanyResponse>(`/company/${companyId}/approve`).then((res) => res.data);
